import { render, staticRenderFns } from "./voiceofcustomer.vue?vue&type=template&id=0a0b102f&scoped=true&"
import script from "./voiceofcustomer.vue?vue&type=script&lang=js&"
export * from "./voiceofcustomer.vue?vue&type=script&lang=js&"
import style0 from "./voiceofcustomer.vue?vue&type=style&index=0&id=0a0b102f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0b102f",
  null
  
)

export default component.exports